import { render, staticRenderFns } from "./TaskRules.vue?vue&type=template&id=33c85dde&scoped=true"
import script from "./TaskRules.vue?vue&type=script&lang=js"
export * from "./TaskRules.vue?vue&type=script&lang=js"
import style0 from "./TaskRules.vue?vue&type=style&index=0&id=33c85dde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c85dde",
  null
  
)

export default component.exports